/* eslint-disable jsx-a11y/anchor-is-valid */
// ProfileCard.js
import React, { useState, useEffect, useCallback, Suspense } from "react";
import QRCodeGenerator from "./QRCodeGenerator";
import ErrorBoundary from "./ErrorBoundary";
import GoogleHotels from "./GoogleHotels";
import Tripadvisor from "./Tripadvisor";
import HolidayCheck from "./HolidayCheck";
import WebSite from "./WebSite";
import App from "./App";
import Facebook from "./Facebook";
import Instagram from "./Instagram";
import VCard from "./vCard";
import Share from "./Share";
import "./ProfileCard.css";

const ProfileCard = () => {
  const [showQRCode, setShowQRCode] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 639);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const handleQRCodeClick = (e) => {
    e.preventDefault();
    setShowQRCode(true);
  };

  const handleCloseQRCode = () => {
    setShowQRCode(false);
  };

  const handleResize = useCallback(() => {
    setIsMobileView(window.innerWidth <= 639);
  }, []);

  const handleInfoClick = (e) => {
    e.preventDefault();
    setShowInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
    <div className="container">
      <div className="card-container">
        <div className="descripcion">
          <h1>Hotel Condesa</h1>
          <h1>* * * *</h1>
          <p />
          <a
            href="https://maps.app.goo.gl/q4xfEqctUhsm5RPeA"
            className="adress-link"
          >
            <p>Carrer Roselles, 4</p>
            <p>07410 Alcúdia, Illes Balears</p>
          </a>
          {/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
          <p></p>
          <p>
            <a href="tel:+34971890119" className="phone-link">
              <i className="bi bi-telephone" /> HOTEL +34 971 890 119
            </a>
          </p>
          <p>
            <a href="tel:+34971890120" className="phone-link">
              <i className="bi bi-telephone" /> BOOK +34 971 890 120
            </a>
          </p>
          <p>
            <a href="mailto:info@hotelcondesa.com" className="email-link">
              info@hotelcondesa.com
            </a>
          </p>
          <div className="buttons">
            <GoogleHotels />
            <Tripadvisor />
            <HolidayCheck />
            <WebSite />
            <App />
            <Facebook />
            <Instagram />
            <VCard />
            <Share />
          </div>
        </div>
        <div className="fill" />
        <div className="image">
          <img
            src="/images/profile-image.png"
            alt="Logo Hotel Condesa"
          />
          {!isMobileView && (
            // biome-ignore lint/a11y/useButtonType: <explanation>
            <button
              onClick={handleQRCodeClick}
              className="hover-text qr-button"
            >
              <span className="tooltip-text qr-tooltip-text" id="fade">
                {" "}
                QR{" "}
              </span>
              <i className="bi bi-qr-code" />
            </button>
          )}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a
            href="#"
            onClick={handleInfoClick}
            className="hover-text info-button"
          >
            <span className="tooltip-text info-tooltip-text" id="fade">
              {" "}
              About{" "}
            </span>
            <i className="bi bi-info-circle" />
          </a>
        </div>
      </div>
      {showQRCode && (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <div className="qr-code-overlay" onClick={handleCloseQRCode}>
          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <div
            className="qr-code-container"
            onClick={(e) => e.stopPropagation()}
          >
            <ErrorBoundary>
              <Suspense fallback={<div>Loading QR Code...</div>}>
                <QRCodeGenerator value="https://hotelcondesa.digitalcard.store/" />
              </Suspense>
            </ErrorBoundary>
          </div>
        </div>
      )}
      {showInfoModal && (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <div className="info-modal-overlay" onClick={handleCloseInfoModal}>
          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <div
            className="info-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <a
              href="https://sergiohelou.dev/digitalcard/"
              className="hover-text"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="modal-text-white">Digital Card</span>
              <span className="modal-text-white">by</span>
              <span className="modal-text-cyan">Sergio Helou Dev</span>
            </a>
          </div>
        </div>
      )}
      {isMobileView && (
        <div className="qr-container">
          {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
          <button onClick={handleQRCodeClick} className="hover-text qr-button">
            <span className="tooltip-text qr-tooltip-text" id="fade">
              {" "}
              QR{" "}
            </span>
            <i className="bi bi-qr-code" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
